import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { FormsModule } from '@angular/forms'
import { NgClass } from '@angular/common'

export interface VeiculoTroca {
  itemPropostaId: number
  tipoVeiculoId: number
  tipoVeiculoDescricao: string
  capacidade: number
  valorVenda: number
  custo: number
  origemCidade?: string | null
  origemEstado?: string | null
  origemDescricao?: string | null
  destinoCidade?: string | null
  destinoEstado?: string | null
  destinoDescricao?: string | null
  atual: boolean
}

@Component({
  selector: 'modal-trocar-veiculo',
  standalone: true,
  imports: [MatButtonModule, MatIconModule, MatFormFieldModule, MatInputModule, FormsModule, NgClass],
  template: `
    <div class="trocar-dialog">
      <div class="trocar-header">
        <span class="trocar-title">Trocar Veículo</span>
        <span class="trocar-sub">Selecione um veículo disponível para este grupo</span>
      </div>

      @if (selectedVeiculo && excede(selectedVeiculo)) {
        <div class="warning-banner">
          <mat-icon>warning</mat-icon>
          <span>
            O grupo possui <strong>{{ data.numPassageiros }}</strong> passageiro(s),
            mas este veículo comporta apenas <strong>{{ selectedVeiculo.capacidade }}</strong>.
            Remova ou mova passageiros para ajustar.
          </span>
        </div>
      }

      <div class="filtros-bar">
        <mat-form-field appearance="outline" class="input-tg filtro-field filtro-descricao">
          <mat-label>Descrição</mat-label>
          <input matInput [(ngModel)]="filtroDescricao" />
        </mat-form-field>
        <mat-form-field appearance="outline" class="input-tg filtro-field filtro-capacidade">
          <mat-label>Capacidade</mat-label>
          <input matInput type="number" [(ngModel)]="filtroCapacidade" />
        </mat-form-field>
        <mat-form-field appearance="outline" class="input-tg filtro-field filtro-cidade">
          <mat-label>Origem cidade</mat-label>
          <input matInput [(ngModel)]="filtroOrigemCidade" />
        </mat-form-field>
        <mat-form-field appearance="outline" class="input-tg filtro-field filtro-estado">
          <mat-label>Origem Estado</mat-label>
          <input matInput [(ngModel)]="filtroOrigemEstado" />
        </mat-form-field>
        <mat-form-field appearance="outline" class="input-tg filtro-field filtro-cidade">
          <mat-label>Destino cidade</mat-label>
          <input matInput [(ngModel)]="filtroDestinoCidade" />
        </mat-form-field>
        <mat-form-field appearance="outline" class="input-tg filtro-field filtro-estado">
          <mat-label>Destino Estado</mat-label>
          <input matInput [(ngModel)]="filtroDestinoEstado" />
        </mat-form-field>
      </div>

      <div class="veiculos-list">
        @for (v of veiculosFiltrados(); track v.itemPropostaId) {
          <div class="veiculo-option"
               [ngClass]="{ 'option-selected': selectedVeiculo === v }"
               (click)="selectedVeiculo = v">
            <div class="radio-dot" [ngClass]="{ 'radio-checked': selectedVeiculo === v }"></div>
            <div class="option-info">
              <div class="option-top">
                <span class="option-veiculo">{{ v.tipoVeiculoDescricao }}</span>
                @if (v.atual) {
                  <span class="badge-atual">atual</span>
                }
                @if (excede(v)) {
                  <span class="badge-excede">
                    <mat-icon>warning</mat-icon> capacidade insuficiente
                  </span>
                }
              </div>
              <div class="option-rota">
                <mat-icon>trip_origin</mat-icon>
                <span>{{ rota(v, 'origem') }}</span>
                <mat-icon>arrow_forward</mat-icon>
                <mat-icon>place</mat-icon>
                <span>{{ rota(v, 'destino') }}</span>
              </div>
              <div class="option-valores">
                <span>Venda: {{ fmt(v.valorVenda) }}</span>
                <span>Custo: {{ fmt(v.custo) }}</span>
              </div>
            </div>
            <span class="cap-badge" [ngClass]="{ 'cap-excede': excede(v) }">
              {{ v.capacidade }} PAX
            </span>
          </div>
        }

        @if (data.veiculos.length === 0) {
          <div class="no-veiculos">Nenhum veículo disponível.</div>
        } @else if (veiculosFiltrados().length === 0) {
          <div class="no-veiculos">Nenhum veículo encontrado para os filtros informados.</div>
        }
      </div>

      <div class="trocar-actions">
        <button mat-button class="btn-tg-white" (click)="cancelar()">Cancelar</button>
        <button mat-button class="btn-tg" [disabled]="!selectedVeiculo" (click)="confirmar()">Confirmar</button>
      </div>
    </div>
  `,
  styles: [`
    .trocar-dialog {
      display: flex;
      flex-direction: column;
      width: 900px;
      max-width: 92vw;
      max-height: 85vh;
    }
    .trocar-header {
      padding: 20px 24px 14px;
      border-bottom: 1px solid #e5e7eb;
      display: flex;
      flex-direction: column;
      gap: 4px;
      flex-shrink: 0;
    }
    .trocar-title {
      font-size: 16px;
      font-weight: 600;
      color: #1f2937;
    }
    .trocar-sub {
      font-size: 13px;
      color: #6b7280;
    }
    .warning-banner {
      display: flex;
      align-items: flex-start;
      gap: 10px;
      padding: 10px 16px;
      background: #fffbeb;
      border-bottom: 1px solid #fde68a;
      font-size: 13px;
      color: #92400e;
      flex-shrink: 0;

      mat-icon {
        font-size: 18px;
        width: 18px;
        height: 18px;
        flex-shrink: 0;
        margin-top: 1px;
        color: #d97706;
      }
    }
    .filtros-bar {
      display: flex;
      flex-wrap: wrap;
      gap: 8px 12px;
      padding: 12px 16px 0;
      flex-shrink: 0;
    }
    .filtro-field.filtro-descricao {
      width: 180px;
    }
    .filtro-field.filtro-capacidade {
      width: 130px;
    }
    .filtro-field.filtro-cidade {
      width: 170px;
    }
    .filtro-field.filtro-estado {
      width: 140px;
    }
    .veiculos-list {
      flex: 1;
      overflow-y: auto;
      padding: 12px 16px;
      display: flex;
      flex-direction: column;
      gap: 8px;
    }
    .veiculo-option {
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 12px 14px;
      border: 1px solid #e5e7eb;
      border-radius: 8px;
      cursor: pointer;
      transition: background 0.15s, border-color 0.15s;
      background: #fff;

      &:hover { background: #f9fafb; }
    }
    .option-selected {
      border-color: #ea6218 !important;
      background: #f3d3c1 !important;
    }
    .radio-dot {
      width: 16px;
      height: 16px;
      border-radius: 50%;
      border: 2px solid #d1d5db;
      flex-shrink: 0;
      transition: border-color 0.15s;
    }
    .radio-checked {
      border-color: #ea6218;
      background: radial-gradient(circle, #ea6218 40%, transparent 41%);
    }
    .option-info {
      flex: 1;
      min-width: 0;
      display: flex;
      flex-direction: column;
      gap: 3px;
    }
    .option-top {
      display: flex;
      align-items: center;
      gap: 6px;
      flex-wrap: wrap;
    }
    .option-veiculo {
      font-size: 13px;
      font-weight: 600;
      color: #1f2937;
    }
    .badge-atual {
      font-size: 10px;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.05em;
      background: #dcfce7;
      color: #15803d;
      border: 1px solid #bbf7d0;
      border-radius: 10px;
      padding: 1px 7px;
    }
    .badge-excede {
      display: inline-flex;
      align-items: center;
      gap: 3px;
      font-size: 10px;
      font-weight: 600;
      background: #fef3c7;
      color: #92400e;
      border: 1px solid #fde68a;
      border-radius: 10px;
      padding: 1px 7px;

      mat-icon {
        font-size: 12px;
        width: 12px;
        height: 12px;
      }
    }
    .option-rota {
      display: flex;
      align-items: center;
      gap: 4px;
      font-size: 11px;
      color: #374151;
      flex-wrap: wrap;

      mat-icon {
        font-size: 13px;
        width: 13px;
        height: 13px;
        color: #9ca3af;
      }
    }
    .option-valores {
      display: flex;
      gap: 12px;
      font-size: 11px;
      color: #6b7280;
    }
    .cap-badge {
      font-size: 11px;
      font-weight: 600;
      background: #e0e7ff;
      color: #3730a3;
      border-radius: 12px;
      padding: 2px 10px;
      white-space: nowrap;
      flex-shrink: 0;
    }
    .cap-excede {
      background: #fef3c7;
      color: #92400e;
    }
    .no-veiculos {
      font-size: 13px;
      color: #9ca3af;
      text-align: center;
      padding: 24px 0;
    }
    .trocar-actions {
      display: flex;
      justify-content: flex-end;
      gap: 8px;
      padding: 12px 16px;
      border-top: 1px solid #e5e7eb;
      flex-shrink: 0;
    }
  `],
})
export class ModalTrocarVeiculoComponent {
  selectedVeiculo: VeiculoTroca | null = null

  filtroDescricao = ''
  filtroCapacidade: number | null = null
  filtroOrigemCidade = ''
  filtroOrigemEstado = ''
  filtroDestinoCidade = ''
  filtroDestinoEstado = ''

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { veiculos: VeiculoTroca[]; numPassageiros: number },
    private dialogRef: MatDialogRef<ModalTrocarVeiculoComponent>,
  ) {
    this.selectedVeiculo = this.data.veiculos.find((v) => v.atual) ?? null
  }

  private normalize(value: string): string {
    return value.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  }

  veiculosFiltrados(): VeiculoTroca[] {
    const descricao = this.normalize(this.filtroDescricao)
    const origemCidade = this.normalize(this.filtroOrigemCidade)
    const origemEstado = this.normalize(this.filtroOrigemEstado)
    const destinoCidade = this.normalize(this.filtroDestinoCidade)
    const destinoEstado = this.normalize(this.filtroDestinoEstado)

    return this.data.veiculos.filter((v) => {
      if (descricao && !this.normalize(v.tipoVeiculoDescricao ?? '').includes(descricao)) return false
      if (this.filtroCapacidade != null && v.capacidade !== this.filtroCapacidade) return false
      if (origemCidade && !this.normalize(v.origemCidade ?? '').includes(origemCidade)) return false
      if (origemEstado && !this.normalize(v.origemEstado ?? '').includes(origemEstado)) return false
      if (destinoCidade && !this.normalize(v.destinoCidade ?? '').includes(destinoCidade)) return false
      if (destinoEstado && !this.normalize(v.destinoEstado ?? '').includes(destinoEstado)) return false
      return true
    })
  }

  excede(v: VeiculoTroca): boolean {
    return this.data.numPassageiros > v.capacidade
  }

  rota(v: VeiculoTroca, tipo: 'origem' | 'destino'): string {
    const cidade = tipo === 'origem' ? v.origemCidade : v.destinoCidade
    const estado = tipo === 'origem' ? v.origemEstado : v.destinoEstado
    const descricao = tipo === 'origem' ? v.origemDescricao : v.destinoDescricao
    if (cidade && estado) return `${cidade}/${estado}`
    return cidade || descricao || '-'
  }

  fmt(value: number): string {
    return value?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) ?? '-'
  }

  confirmar() {
    this.dialogRef.close(this.selectedVeiculo)
  }

  cancelar() {
    this.dialogRef.close(null)
  }
}
